export class ScrollLoad<Type> {
  object: Type;
  idKey: string;
  filterKey: string;
  filteringValue: string;
  currentPage = 1;
  allLoaded = false;
  pageSize = 50;
  hasResults: boolean;
  loading: boolean;
  objects: Type[] = [];
  filterData: Record<string, any> = {};

  constructor(pageSize: number, idKey: string, filterKey?: string, filterData?: Record<string, any>) {
    this.idKey = idKey;
    this.filterKey = filterKey;
    this.pageSize = pageSize;
    this.filterData = filterData ? filterData : {};
    this.filterData['page'] = this.currentPage;
    this.filterData['pageSize'] = this.pageSize;
  }

  reset() {
    this.currentPage = 1;
    this.filteringValue = null;
    this.object = null;
    this.objects = [];
  }
}
